/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Ocr_Processing_FramesInputs */



/**
* | output |
* | --- |
* | "Processing OCR... {current}/{total} frames" |
*
* @param {Ocr_Processing_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_processing_frames = /** @type {((inputs: Ocr_Processing_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Processing_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Traitement OCR... ${i?.current}/${i?.total} images`)
	if (locale === "de") return /** @type {LocalizedString} */ (`OCR-Verarbeitung... ${i?.current}/${i?.total} Frames`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Elaborazione OCR... ${i?.current}/${i?.total} frame`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обработка OCR... ${i?.current}/${i?.total} кадров`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Procesando OCR... ${i?.current}/${i?.total} fotogramas`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在处理 OCR... ${i?.current}/${i?.total} 帧`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`OCR処理中... ${i?.current}/${i?.total} フレーム`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`OCR प्रक्रिया जारी है... ${i?.current}/${i?.total} फ्रेम`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Processando OCR... quadros ${i?.current}/${i?.total}`)
	return /** @type {LocalizedString} */ (`Processing OCR... ${i?.current}/${i?.total} frames`)
});